"use strict";
var util_1 = require("../utils/util");
var Dictionary = (function () {
    function Dictionary() {
        this.keys = [];
        this.values = [];
    }
    Dictionary.prototype.get = function (key) {
        var index = this.keys.indexOf(key);
        if (index < 0) {
            return null;
        }
        return this.values[index];
    };
    Dictionary.prototype.add = function (key, o) {
        var index = this.keys.indexOf(key);
        if (index > -1) {
            this.values[index] = o;
        }
        else {
            this.keys.push(key);
            this.values.push(o);
        }
    };
    Dictionary.prototype.merge = function (source) {
        if (util_1.Util.isFunction(source["getKeys"])) {
            var sourceAsDictionary = source;
            var keys = sourceAsDictionary.getKeys();
            var l = keys.length;
            for (var i = 0; i < l; i++) {
                this.add(keys[i], sourceAsDictionary.get(keys[i]));
            }
        }
        else {
            var sourceAsHash = source;
            for (var key in sourceAsHash) {
                if (sourceAsHash.hasOwnProperty(key)) {
                    this.add(key, source[key]);
                }
            }
        }
    };
    Dictionary.prototype.remove = function (key) {
        var index = this.keys.indexOf(key);
        if (index < 0) {
            return null;
        }
        var val = this.values[index];
        this.keys.splice(index, 1);
        this.values.splice(index, 1);
        return val;
    };
    Dictionary.prototype.getKeys = function () {
        return this.keys;
    };
    Dictionary.prototype.getValues = function () {
        return this.values;
    };
    Dictionary.prototype.clear = function () {
        this.keys = [];
        this.values = [];
    };
    Dictionary.prototype.count = function () {
        return this.keys.length;
    };
    return Dictionary;
}());
exports.Dictionary = Dictionary;
